import { useContext, useState } from "react";
import { useSubmit } from "react-router-dom";

import MenuContext from '../../store/MenuContext';
import TestInfoClasses from '../Tests/TestInfo.module.css';

const AdultsOnly = (props) => {
	const submit = useSubmit();
	const menuTheme = useContext(MenuContext);

    return (
			<div className={TestInfoClasses.testInfo}>
				<div className={TestInfoClasses.testInfoContent}>
    	    		<div className={TestInfoClasses.buttonArea}>
	    	    		<span>&nbsp;</span>
	    	    		<br/><br/><br/><br/><br/><br/><br/><br/>
	    	    		<span>Are you 18 years of age or older?</span>
	    	    		<span>&nbsp;</span>
    	    		</div>
			     </div>
            </div>
        
    );
};

export default AdultsOnly;
